export const serverSide: boolean = typeof window === 'undefined'
